import { useState } from "react";
import {
  TextField,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import Logo from "./../image/ClearVault_logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  };

  const handleReset = async () => {
    if (!email) {
      setError("Email address is required.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");
    setError("");
    setSubmitted(false);

    try {
      const res = await axios.post("/cvault/forgot-password/", { email: email });
      setMessage(`Password reset email sent to ${email}. Check your inbox.`);
      setSubmitted(true);
    } catch (err) {
      setError(err?.response?.data?.error || err?.response?.data?.detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f8f9fb",
          // p: 1, // Reduced padding for the outer Box
        }}
      >
        <Card
          sx={{ maxWidth: 400, p: 2, boxShadow: "none", marginTop: "auto" }}
        >
          {" "}
          {/* Reduced padding and width */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <img src={Logo} alt="Logo" style={{ width: "90px" }} />{" "}
            {/* Reduced logo size */}
          </Box>
          {!submitted && (
            <>
              <CardHeader
                title={
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", fontWeight: "500" }}
                  >
                    Forgot password?
                  </Typography>
                }
              />
              <Typography
                sx={{
                  color: "#8687A3",
                  fontSize: "0.85rem",
                  textAlign: "center",
                }}
              >
                Enter your email address and we will send you instructions to
                reset your password.
              </Typography>
            </>
          )}
          <CardContent sx={{ p: 1 }}>
            {" "}
            {/* Reduced padding */}
            {!submitted ? (
              <>
                <label className="mb-1 ps-0">
                  <h6 className="mb-0 text-sm">Email Address</h6>
                </label>

                <TextField
                  fullWidth
                  variant="outlined"
                  type="email"
                  margin="normal"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.replace(/\s/g, ""))}
                  helperText={error}
                  error={!!error}
                  sx={{
                    marginTop: "0px",
                    "& .MuiOutlinedInput-root": {
                      fontSize: "0.75rem",
                      "& fieldset": {
                        borderColor: "#D0D5DD",
                        borderRadius: "4px",
                        padding: "12px 0px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#D0D5DD",
                        borderRadius: "4px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#667085",
                        borderWidth: "1px",
                        borderRadius: "4px",
                      },
                    },
                  }}
                />
                <Button
                  onClick={handleReset}
                  fullWidth
                  variant="contained"
                  sx={{
                    marginTop: "5px", // Reduced margin
                    backgroundColor: "#1A237E",
                    color: "#fff",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#0D1B64", // Custom hover color
                    },
                  }}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Reset Password"}
                </Button>
              </>
            ) : (
              <Typography sx={{ mt: 2, textAlign: "center", color: "#708090" }}>
                {message}
              </Typography>
            )}
            <Button
              fullWidth
              sx={{
                marginTop: "8px",
                color: "#1A237E",
                textTransform: "none",
              }}
              type="button"
              onClick={() => navigate("/login")}
            >
              Back to Login
            </Button>
          </CardContent>
        </Card>
        <footer className="footer mt-auto text-center py-3 w-100">
          <div className="row px-3">
            {" "}
            <small className="ml-4 ml-sm-5 mb-2">
              Copyright &copy; 2025. All rights reserved.
            </small>
          </div>
        </footer>
      </Box>
    </div>
  );
};

export default ForgotPassword;
